<template>
  <modal v-if="mappingField" :show="show" @close="close" style="min-width: 50%;">
    <template #title>
      {{ trans('dashboard.integrations.flows.data_mapping.configure_data_mapping_field_for_x', {application}) }}
    </template>
    <template #content>
      <div class="mt-4">
        <form-input
          v-model="form.mapping_field_name"
          type="input"
          :label-text="trans('dashboard.integrations.flows.data_mapping.reference_field')"
          :error="form.errors.mapping_field_name"
          disabled
        />
      </div>
      <div class="mt-4">
        <div class="flex justify-content-between align-items-center mb-2">
          <form-input-label class="form_label w-auto mb-0"
                            :value="trans('dashboard.integrations.flows.data_mapping.field_in_x', {application})"/>
          <a v-if="!isDefaultValue('mapping_field_value', mappingFieldValueColumn)"
             class="px-2 mt-1 text-sm cursor-pointer"
             @click="resetToDefault('mapping_field_value', mappingFieldValueColumn)">
            {{ trans('dashboard.integrations.flows.back_to_default') }}
          </a>
        </div>
        <form-input
          v-model="form.mapping_field_value"
          type="select"
          :options="options"
          :error="form.errors.mapping_field_value"
          :placeholder="trans('dashboard.integrations.flows.select_an_option')"
          :taggable="true"
          @tag="addCustomMappingFieldValue"
        />
      </div>
      <div class="mt-4">
        <div class="flex justify-content-between align-items-center mb-2">
          <form-input-label class="form_label w-auto mb-0"
                            :value="trans('dashboard.integrations.flows.data_mapping.micro_function')"/>
          <a v-if="!isDefaultValue('micro_function', microFunctionColumn)"
             class="px-2 mt-1 text-sm cursor-pointer"
             @click="resetToDefault('micro_function', microFunctionColumn)">
            {{ trans('dashboard.integrations.flows.back_to_default') }}
          </a>
        </div>
        <form-input
          v-model="form.micro_function"
          type="select"
          :options="microFunctions"
          :error="form.errors.micro_function"
          :placeholder="trans('dashboard.integrations.flows.select_an_option')"
        />
      </div>
    </template>
    <template #footer>
      <form-button class="button_cancel" :value="trans('common.cancel')" @click="close"/>

      <form-button class="ml-3"
                   :value="trans('common.update')"
                   :processing-value="trans('common.updating')"
                   :processing="form.processing"
                   @click="update"/>
    </template>
  </modal>
</template>

<script>
import {useForm} from "@inertiajs/vue3";
import Modal from "@/components/Shared/Modal";
import FormButton from "@/components/Shared/Form/Button";
import FormInput from "@/components/Shared/Form/Input/Index";
import FormInputLabel from "@/components/Shared/Form/Input/Label.vue";

export default {
  name: "FlowDataMappingConfigureModal",

  components: {
    FormInputLabel,
    Modal,
    FormInput,
    FormButton
  },

  emits: ['close', 'update'],

  props: {
    show: Boolean,
    userIntegrationId: [String, Number],
    userIntegrationFlowId: [String, Number],
    isFirstSide: Boolean,
    application: String,
    flowId: [String, Number],
    mappingField: Object,
    options: Array,
    microFunctions: Array,
  },

  data: () => ({
    form: useForm({
      flow_id: '',
      mapping_field_name: '',
      mapping_field_value: '',
      micro_function: '',
    })
  }),

  computed: {
    mappingFieldValueColumn() {
      return this.isFirstSide ? 'mapping_field_value_1' : 'mapping_field_value_2';
    },

    microFunctionColumn() {
      return this.isFirstSide ? 'micro_function_1' : 'micro_function_2';
    }
  },

  watch: {
    show: function (value) {
      if (value) {
        this.form.reset()
        this.form.clearErrors()

        this.form.flow_id = this.flowId
        this.form.mapping_field_name = this.mappingField.mapping_field_name
        this.form.mapping_field_value = this.mappingField[this.mappingFieldValueColumn]
        this.form.micro_function = this.mappingField[this.microFunctionColumn]
      }
    }
  },

  methods: {
    addCustomMappingFieldValue(value) {
      this.options.push(value)
      this.form.mapping_field_value = value
    },

    isDefaultValue(attribute, column) {
      return this.mappingField['default_values'][column] === this.form[attribute]
    },

    resetToDefault(attribute, column) {
      this.form[attribute] = this.mappingField['default_values'][column]
    },

    update() {
      const form = this.form
      const self = this;

      form.processing = true
      form.clearErrors()

      axios
        .patch(`/api/integrations/${this.userIntegrationId}/flows/${this.userIntegrationFlowId}/data-mapping`, form)
        .then(function (response) {
          for (let column of [self.mappingFieldValueColumn, self.microFunctionColumn]) {
            self.mappingField[column] = response.data[column]
            self.mappingField['is_default'][column] = response.data['is_default'][column]
          }

          self.close()
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            form.setError(error.response.data.errors)
          } else {
            throw error
          }
        })
        .finally(() => form.processing = false)
    },

    close() {
      this.$emit('close')
    }
  },
}
</script>
